export default __webpack_public_path__ + "static/media/trayvonMartin.8e295b20.png";